import { useMutation } from "@tanstack/react-query";
import { PatientPortalNotificationControllerApi } from "../../services";
import { getConfigObject, getXtenantId } from "../../utils/utils";

export const usePatientPortalMarkRead = () =>
  useMutation({
    mutationFn: async ({ notificationUuid }: { notificationUuid: string }) =>
      await new PatientPortalNotificationControllerApi(getConfigObject())
        .markAsRead(notificationUuid, getXtenantId() ?? undefined)
        .then((res) => res?.data),
  });

export const usePatientPortalMarkAllRead = () =>
  useMutation({
    mutationFn: async ({ patientUuid }: { patientUuid: string }) =>
      await new PatientPortalNotificationControllerApi(getConfigObject())
        .markAllAsRead(patientUuid, getXtenantId() ?? undefined)
        .then((res) => res?.data),
  });
